import { isVideo, isImage } from './utils';
export default {
  props: {
    videoTypeList: {
      type: Array,
      default: () => []
    },
    fileList: {
      type: Array,
      default: () => [],
      required: true
    },
    currentIndex: {
      type: Number,
      required: true
    },
    visible: {
      type: Boolean,
      default: false,
      required: true
    },
    show: {
      type: String,
      default: 'image',
      required: true
    },
    src: {
      type: String,
      default: '',
      required: true
    }
  },
  watch: {
    visible(newVal) {
      this.previewVisible = newVal;
      this.index = this.currentIndex;
    },
    show(newVal) {
      this.isShow = newVal;
    },
    src(newVal) {
      this.$nextTick(() => {
        const video = document.querySelector('#video');
        if (video) {
          video.src = newVal;
        }
      });
      this.showSrc = newVal;
    },
    currentIndex(newVal) {
      this.index = newVal;
    }
  },
  data() {
    return {
      index: 0,
      previewVisible: false,
      isShow: '',
      showSrc: '',
      isPDF: false
    };
  },
  methods: {
    getType(file) {
      this.isPDF = false;
      if (isVideo(file.name)) {
        this.isShow = 'video';
        this.$nextTick(() => {
          const video = document.querySelector('#video');
          video.src = file.url || file.response.data.fileTempUrl;
        });
      } else if (isImage(file.name)) {
        this.isShow = 'image';
        this.showSrc = file.url || file.preview || file.response.data.fileTempUrl;
      } else {
        this.isPDF = true;
      }
    },
    showLast() {
      if (this.index !== 0) {
        this.index -= 1;
        this.getType(this.fileList[this.index]);
        if (!this.isPDF) {
          return;
        }
        this.showLast();
        // if (this.isPDF) {
        //   this.showLast();
        // } else {
        // this.showSrc =
        //   this.fileList[this.index].url ||
        //   this.fileList[this.index].preview ||
        //   this.fileList[this.index].response.data.fileTempUrl;
        // return;
        // }
      }
      if (this.index === 0) {
        this.$message.warn(this.$t('已经是第一张了'));
      }
    },
    showNext() {
      if (this.index < this.fileList.length - 1) {
        this.index += 1;
        this.getType(this.fileList[this.index]);
        if (!this.isPDF) {
          return;
        }
        this.showNext();
      }
      if (this.index === this.fileList.length - 1) {
        this.$message.warn(this.$t('已经是最后一张了'));
      }
    },
    closePreview(e) {
      this.$emit('cancel', e);
      if (this.isShow === 'video') {
        // 视频预览关闭暂停播放
        const video = document.querySelector('#video');
        video.currentTime = 0;
        video.pause();
        this.showSrc = '';
      }
    }
  }
};